import * as Q from 'q';
import * as $ from 'jquery';
import * as globalConfig from 'globalConfig';

// Models
import { PostCodeLookupReturnModel } from "Content/ts/Models/Shared/PostCode/PostCodeLookupResultModel";
import { SystemConfigurationModel } from 'Content/ts/Models/Shared/SystemConfigurationModel';

export module PostCodeLookupService {
    export function PostCodeSearch(houseNameOrNumber: string, postCode: string): Q.Promise<PostCodeLookupReturnModel> {
        return Q($.ajax({
            url: globalConfig.Urls.Account.PostCode.PostCodeLookup,
            method: 'GET',
            cache: false,
            data: { houseNameOrNumber: houseNameOrNumber, postcode: postCode }
        }));
    };

    export function PostcodeLookupEnabled(): Q.Promise<SystemConfigurationModel> {
        return Q($.ajax({
            url: globalConfig.Urls.Configuration.GetConfigurationBySettingName.replace('{settingName}', 'PostcodeLookupEnabled'),
            method: 'GET',
            cache: false
        }));
    }
}